<script setup lang="ts">
import {onBeforeUnmount, onMounted, type Ref, ref} from "vue";

interface Props {
    enabled: boolean | 1 | 0
}


const props = withDefaults(defineProps<Props>(), {
    enabled: false
})

const currentElement: Ref<HTMLElement | null> = ref(null)

const preventClick = (event: Event): boolean => {
    event.preventDefault()
    event.stopImmediatePropagation()
    event.stopPropagation()
    event.preventDefault()
    return false;
}

onMounted(() => {
    if (props.enabled) {
        if (currentElement.value === null) throw new Error("unable to prevent interaction: currentElement is null")

        for (const element of currentElement.value.querySelectorAll('*')) {
            element.setAttribute('tabindex', '-1')
            element.classList.add('outline-hidden')
            element.addEventListener('click', preventClick, true)
        }
    }
})

onBeforeUnmount(() => {
    if (props.enabled) {
        if (currentElement.value === null) throw new Error("unable to revert-prevent interaction: currentElement is null")

        for (const element of currentElement.value.querySelectorAll('*')) {
            element.removeAttribute('tabindex')
            element.classList.remove('outline-hidden')
            element.removeEventListener('click', preventClick)
        }
    }
})

</script>

<template>
    <div class="relative" ref="currentElement" tabindex="-1">
        <slot/>
        <!--        <div class="absolute bg-red-500/10 top-0 left-0 w-full h-full z-9999" v-if="enabled"></div>-->
    </div>
</template>
